import axios from "axios";
import { Config } from "../../data/config";
export const SET_STATUS = "STATUS | SET_STATUS";
export const RESET_STATUS = "STATUS | RESET_STATUS";

export function fetchStatus() {
  return function(dispatch) {
    axios.get(`${Config.frontApiUrl}/status`).then((response) => {
      dispatch(
        setStatus({
          internet: response.data.internet || [],
          phone: response.data.phone || [],
          tv: response.data.tv || [],
        })
      );
    });
  };
}

export function setStatus(data) {
  return { type: SET_STATUS, payload: data };
}

export function resetStatus() {
  return { type: RESET_STATUS };
}

export function outageNotify(data) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${Config.frontApiUrl}/outage/notify`, data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/status.js